(function () {
  'use strict';

  var qs  = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.from((c || document).querySelectorAll(s)); };

  /* ── Gallery ─────────────────────────────────────────── */

  function initGallery() {
    var gallery  = qs('[data-product-gallery]');
    if (!gallery) return;

    var slidesEl  = qs('[data-pg-slides]', gallery);
    var slides    = qsa('.pg__slide', gallery);
    var thumbs    = qsa('.pg__thumb', gallery);
    var dots      = qsa('.pg__dot', gallery);
    var arrowPrev = qs('[data-pg-prev]', gallery);
    var arrowNext = qs('[data-pg-next]', gallery);
    var total     = slides.length;
    var current   = 0;
    var scrollSyncTimer;

    if (!slidesEl || total === 0) return;

    function updateArrows() {
      if (arrowPrev) arrowPrev.hidden = current === 0;
      if (arrowNext) arrowNext.hidden = current === total - 1;
    }

    function goTo(idx, behavior) {
      if (idx < 0) idx = total - 1;
      if (idx >= total) idx = 0;
      current = idx;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i)   { d.classList.toggle('is-active', i === idx); });
      updateArrows();
      slides[idx].scrollIntoView({ behavior: behavior || 'smooth', block: 'nearest', inline: 'center' });
      var at = thumbs[idx];
      if (at) at.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function   (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    if (arrowPrev) arrowPrev.addEventListener('click', function () { goTo(current - 1); });
    if (arrowNext) arrowNext.addEventListener('click', function () { goTo(current + 1); });

    /* Native scroll-snap now drives touch/trackpad swipe directly on
       .pg__slides. Once the scroll settles, sync dots/thumbs/arrows to
       whichever slide the browser landed on. */
    slidesEl.addEventListener('scroll', function () {
      clearTimeout(scrollSyncTimer);
      scrollSyncTimer = setTimeout(function () {
        var mid = slidesEl.scrollLeft + slidesEl.clientWidth / 2;
        var closest = 0, closestDist = Infinity;
        slides.forEach(function (s, i) {
          var center = s.offsetLeft + s.offsetWidth / 2;
          var dist = Math.abs(center - mid);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        if (closest !== current) goTo(closest, 'auto');
      }, 120);
    }, { passive: true });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    window.__pgGoToSrc = function (src) {
      var idx = thumbs.findIndex(function (t) { return t.dataset.src === src; });
      if (idx >= 0) goTo(idx);
    };

    goTo(0, 'auto');
  }

  /* ── Magnifier loupe (desktop only) ─────────────────── */

  function initMagnifier() {
    if (!window.matchMedia('(min-width: 768px)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var ZOOM = 1.8;
    var SIZE = 300;
    var OFFSET = 20;

    qsa('.pg__main-wrap').forEach(function (mainWrap) {
      var loupe = document.createElement('div');
      loupe.className = 'pg__loupe';
      mainWrap.appendChild(loupe);

      function getActiveImg() {
        var slide = qs('.pg__slide.is-active', mainWrap);
        var img = slide ? qs('.pg__img', slide) : qs('.pg__img', mainWrap);
        return (img && img.src) ? img : null;
      }

      mainWrap.addEventListener('mousemove', function (e) {
        var img = getActiveImg();
        if (!img) {
          loupe.classList.remove('is-visible');
          return;
        }

        var rect = mainWrap.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
          loupe.classList.remove('is-visible');
          return;
        }

        var bgUrl = 'url(' + img.src + ')';
        if (loupe.style.backgroundImage !== bgUrl) loupe.style.backgroundImage = bgUrl;

        var bgWidth  = rect.width * ZOOM;
        var bgHeight = rect.height * ZOOM;
        loupe.style.backgroundSize = bgWidth + 'px ' + bgHeight + 'px';

        var bgX = Math.max(0, Math.min((x / rect.width) * bgWidth - SIZE / 2, bgWidth - SIZE));
        var bgY = Math.max(0, Math.min((y / rect.height) * bgHeight - SIZE / 2, bgHeight - SIZE));
        loupe.style.backgroundPosition = '-' + bgX + 'px -' + bgY + 'px';

        var left = x + OFFSET;
        if (left + SIZE > rect.width) left = x - OFFSET - SIZE;

        var top = Math.max(0, Math.min(y - SIZE / 2, rect.height - SIZE));

        loupe.style.left = left + 'px';
        loupe.style.top  = top + 'px';
        loupe.classList.add('is-visible');
      });

      mainWrap.addEventListener('mouseleave', function () {
        loupe.classList.remove('is-visible');
      });
    });
  }

  /* ── Bundle selector ─────────────────────────────────── */

  var bundleQty = 1;

  function initBundle() {
    var bundle = qs('[data-bundle]');
    if (!bundle) return;

    var options = qsa('.pi-bundle__option', bundle);

    function selectOption(opt) {
      options.forEach(function (o) { o.classList.remove('is-selected'); });
      opt.classList.add('is-selected');
      bundleQty = parseInt(opt.dataset.bundleOption || '1', 10);
    }

    // ?qty=2|3|4 (from the homepage quantity chips) preselects that card; anything else → 1.
    var wanted = new URLSearchParams(window.location.search).get('qty');
    if (['2', '3', '4'].indexOf(wanted) < 0) wanted = '1';

    options.forEach(function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (opt.dataset.bundleOption === wanted) {
        selectOption(opt);
        if (radio) radio.checked = true;
      }
      opt.addEventListener('click', function () { selectOption(opt); });
    });
  }

  /* ── Color swatch notify-me ──────────────────────────── */

  function initColorSwatches() {
    var wrap = qs('[data-color-swatches]');
    if (!wrap) return;

    qsa('.pi-color-wrap', wrap).forEach(function (cw) {
      var btn     = qs('.pi-color', cw);
      var tooltip = qs('.pi-color__tooltip', cw);
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (btn.dataset.available === 'true') {
          qsa('.pi-color', wrap).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        } else if (tooltip) {
          tooltip.removeAttribute('hidden');
          clearTimeout(btn.__tooltipTimer);
          btn.__tooltipTimer = setTimeout(function () {
            tooltip.setAttribute('hidden', '');
          }, 2200);
        }
      });
    });
  }

  /* ── Popup triggers ──────────────────────────────────── */

  function initPopupTriggers() {
    qsa('[data-open-popup]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var popup = document.getElementById(btn.dataset.openPopup);
        if (!popup) return;
        popup.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        popup.dispatchEvent(new CustomEvent('popup:open', {
          bubbles: true,
          detail: {
            totalMagnets: bundleQty,
            variantId:    btn.dataset.variantId,
            productId:    btn.dataset.productId,
            magnetShape:  btn.dataset.shape || btn.dataset.magnetShape
          }
        }));
      });
    });
  }

  /* ── Init ────────────────────────────────────────────── */

  function init() {
    initGallery();
    initMagnifier();
    initBundle();
    initColorSwatches();
    initPopupTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
